import {Component, OnInit} from '@angular/core';
import {SortingComponent} from '../sorting.component';
import {User} from '../classes/user.class';
import {Router} from '@angular/router';
import {CordovaService} from '../cordova.service';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {AuthorisationService} from '../services/auth/authorisation.service';
import {LocalStorage} from '../storage.class';
import {formatDate} from '@angular/common';
import {SmallMaterialStatus} from '../smallmaterial-status';
import {SmallMaterialRequest} from '../smallmaterial-request';
import {SmallMaterialService} from '../services/small-material.service';

@Component({
    selector: 'app-small-material-request',
    templateUrl: './small-material-request.component.html',
    styleUrls: ['./small-material-request.component.scss']
})
export class SmallMaterialRequestComponent extends SortingComponent<SmallMaterialRequest> implements OnInit {

    user: User;
    statusIds = [1, 2, 4, 8];
    statusList: SmallMaterialStatus[];
    currentSort = 'created_at';
    desc = true;
    showStatusFilter = true;

    constructor(private router: Router,
                private cordovaService: CordovaService,
                private confirmDialog: ConfirmDialogService,
                private smallMaterialService: SmallMaterialService) {
        super();
    }

    ngOnInit(): void {
        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/']);
        });
        if (!AuthorisationService.hasFeature('smallMaterialManagement')) {
            this.statusIds = [1, 2, 3, 4, 5, 6, 7, 8];
            this.showStatusFilter = false;
        }
        this.getData();
        this.user = LocalStorage.getUser();
        this.smallMaterialService.statusList().subscribe(status => {
            this.statusList = status.data;
        });
    }

    public getData() {
        this.smallMaterialService.listRequests(this.statusIds).subscribe(requests => {
            this.list = requests.data;
        });
    }

    delete(event, smallMaterialRequest: SmallMaterialRequest) {
        event.stopPropagation();
        this.confirmDialog.confirm(
            'Aanvraag intrekken',
            `Weet u zeker dat u deze aanvraag aangemaakt op ${formatDate(smallMaterialRequest.created_at, 'd MMM yyyy, H:mm', 'nl')} wilt intrekken?`,
            'Intrekken',
            'Behouden'
        ).then(() => {
            this.smallMaterialService.deleteRequest(smallMaterialRequest.id).subscribe(() => {
                const index = this.list.indexOf(smallMaterialRequest);
                this.list.splice(index, 1);
            });
        }, () => {

        });
    }

}
